// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__lGRFp","colMin":"styles_colMin__3D2iW","colCheckbox":"styles_colCheckbox__15vni"};